import type { Media } from '@/lib/api'

/** Renders a puzzle's optional media (image/audio/video), independent of puzzle type. */
export function MediaGallery({ media }: { media: Media[] }) {
  if (media.length === 0) return null
  return (
    <div className="media">
      {media.map((m, i) => (
        <figure key={`${m.url}-${i}`}>
          {m.type === 'image' && <img src={m.url} alt={m.alt ?? ''} loading="lazy" />}
          {m.type === 'audio' && <audio controls src={m.url} preload="metadata" />}
          {m.type === 'video' && <video controls playsInline src={m.url} preload="metadata" />}
          {m.caption && <figcaption className="muted">{m.caption}</figcaption>}
        </figure>
      ))}
    </div>
  )
}
